import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "layoutRef", "children"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ApplicationLayoutHeader from './ApplicationLayoutHeader';
import ApplicationLayoutSidebar from './ApplicationLayoutSidebar';
import ApplicationLayoutBody from './ApplicationLayoutBody';

// initializes document bootstrapping - keep the import to avoid being tree-shaked
import { initDocumentBootstrapping } from '../../utils/init';
initDocumentBootstrapping;
export var ApplicationLayout = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    layoutRef = props.layoutRef,
    children = props.children,
    remainigProps = _objectWithoutProperties(props, _excluded);
  var classes = classNames('ApplicationLayout', className);
  return /*#__PURE__*/React.createElement("div", _extends({}, remainigProps, {
    ref: ref || layoutRef,
    className: classes
  }), children);
});
ApplicationLayout.Header = ApplicationLayoutHeader;
ApplicationLayout.Sidebar = ApplicationLayoutSidebar;
ApplicationLayout.Body = ApplicationLayoutBody;
ApplicationLayout.propTypes = {
  className: PropTypes.string,
  layoutRef: PropTypes.func
};
export default ApplicationLayout;